import PreselectSeatUIModel from './preselect-seat';
class PreselectSeatsTravelersUIModel {
  constructor({
    preselectSeat = [],
  }) {
    this.preselectSeats = Object.keys(preselectSeat).map(indexTraveler => {
      if ( indexTraveler ) {
        return preselectSeat[indexTraveler].map((seatSelected) => {
          if ( Object.keys(seatSelected).length > 0 ) {
            return new PreselectSeatUIModel(seatSelected);
          } else {
            return {};
          }
        });
      }
    });
  }
}

export default PreselectSeatsTravelersUIModel;